import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { GET, GET_WARRANTY_INFO_CODE } from '../../../../services';

export const useGetWarrantyEdit = ({ warrantyCode, reset, getValues }) => {
  const [data, setData] = useState();

  const { isPending, mutate } = useMutation({
    mutationFn: async () => {
      const response = await GET(GET_WARRANTY_INFO_CODE(warrantyCode));
      return response.result;
    },
    onSuccess: (result) => {
      const w = result?.warranty;
      if (!w) {
        setData(result);
        return;
      }
      const { warrantyData, ...warrantyFormFields } = w;
      const resetPayload = {
        ...getValues(),
        ...warrantyFormFields,
        invImageUrl: [{ uid: w.invImageUrl, url: w.invImageUrl }],
        packageImageUrl: [{ uid: w.packageImageUrl, url: w.packageImageUrl }],
      };
      const mobilesList = warrantyData?.mobiles;
      if (Array.isArray(mobilesList) && mobilesList.length > 0) {
        mobilesList.forEach((m, i) => {
          const rowNum = i + 1;
          if (m.warrantyMobileId != null && m.warrantyMobileId !== '') {
            resetPayload[`warrantyMobileId${rowNum}`] = m.warrantyMobileId;
          }
          if (i === 0) {
            resetPayload.mobileBrandId = m.mobileBrandId;
            resetPayload.mobileModelName = m.mobileModelName;
          } else {
            const num = i + 1;
            resetPayload[`mobileBrandId${num}`] = m.mobileBrandId;
            resetPayload[`mobileModelName${num}`] = m.mobileModelName;
          }
        });
      }
      reset(resetPayload);
      setData(result);
    },
  });

  useEffect(() => {
    if (warrantyCode) {
      mutate();
    }
  }, [warrantyCode]);

  return { dataSource: data, setData, onSearch: mutate, loading: isPending };
};
